//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import apiService from '../services/APIService'
import APIService from "../services/APIService";
export default {
  data() {
    return {
      categories: ["firma", "ort", "arbeitsbereich"],
      firmen: [],
      orte: [],
      arbeitsbereiche: [],
      stellen: [],
      stellenOrig: [],
      loading: false,
      result: [],
      search: '',
      sortBy: 'lastOpened',
      sortDesc: true,
      showTaxonomy: [true, false, false],
      taxonomySelected: [],
      taxonomyTerms: [],
      showUnternehmen: true,
      showOrte: false,
      showArbeitsbereiche: false,
      firmenSelected: [],
      orteSelected: [],
      arbeitsbereicheSelected: [],
      arbeitsbereichTxt: "Arbeitsbereich",
      ortTxt: "Standort",
      firmaTxt: "Unternehmen",
      taxonomies: [],
      opacity: 0,
      overlay: false,
      displayActivityIndicator: false,
      iFrameURL: "https://www.bz-af.de",
      showiFrame: false,
      overlayTitle: "",
      showHtmlOverlay: true,
      overlay_html: "",
      post_link: "",
      showNoFilterText: true
    }
  },
  methods: {
    hideActivityIndicator(){
      this.displayActivityIndicator = false;
    },
    showActivityIndicator(){
      this.displayActivityIndicator = true;
    },
    hideOverlay() {
      //this.showiFrame = false;
      document.querySelector('body').style.overflow = 'scroll';
      this.overlay = false;
      this.displayActivityIndicator = false;
    },
    resetFilter(){
      for(let i=0; i<this.taxonomySelected.length; i++){
        this.taxonomySelected[i] = [];
      }
      this.search = "";
      this.showNoFilterText = true;
      document.getElementById('nofilterhint').style.display = "block";
      this.filterPostsByTerms();
    },
    checkedTerm(event, name){
      console.log(name);
      console.log(event);
    },
    itemSelected(item){

      if(window.$config.openInFrame){
        this.iFrameURL = item.permalink+"?fa=1";
        this.overlay_html = item.description_html;
        this.post_link = item.permalink;
        if(item.description_html == ""){
          document.querySelector('body').style.overflow = 'hidden';
          this.showiFrame = true;
          this.showHtmlOverlay = false;
          this.showActivityIndicator();
        }else{
          this.showiFrame = false;
          this.showHtmlOverlay = true;
        }
        this.overlay = true;
      }else{
        window.open(item.permalink, '_blank');
      }
    },
    showTerms(name, index){
      for(let i=0; i < this.taxonomies.length; i++){
        this.taxonomies[i].show = false;
      }
      this.taxonomies[index].show = true;

      //hack to update v-for
      let dummy = {"show": false};
      this.taxonomies.push(dummy);
      this.taxonomies.pop();

      /*
      this.showUnternehmen = false;
      this.showOrte = false;
      this.showArbeitsbereiche = false;
      switch(name){
        case "firmen":{
          this.showUnternehmen = true;
          break;
        }
        case "orte":{
          this.showOrte = true;
          break;
        }
        case "arbeitsbereiche":{
          this.showArbeitsbereiche = true;
          break;
        }
      }*/
    },
    showInfo(info) {
      this.$refs.manufacturerPostDialog.show(info)
    },
    queryInfo() {
      this.loading = true
      this.result = []
      apiService.searchManufacturerInfo(this.query).then((result) => {
        this.loading = false
        this.result = result
      })
    },
    async getTaxonomies(){
      for(let i=0; i < this.taxonomies.length; i++){
        let ts =  await APIService.getTaxonomieTerms(this.taxonomies[i].slug);
        //Sort by position
        ts = ts.sort(function(a, b) {
          return a.position - b.position;
        });

        this.taxonomies[i].taxonomyTerms = ts;
      }

      /*
      this.orte = await APIService.getTaxonomieTerms('ort');
      this.firmen = await APIService.getTaxonomieTerms('firma');
      this.arbeitsbereiche = await APIService.getTaxonomieTerms('arbeitsbereich');
      */
    },
    async getStellen(){
      console.log("show activity");
      this.showActivityIndicator();
      this.stellen = await APIService.getStellen();
      console.log("get stellen");
      console.log(this.stellen);
      this.hideActivityIndicator();
      let that = this;
      this.stellen.forEach(function(stelle){
        for(let i = 0; i < window.$config.taxonomies.length; i++){
          //console.log("get taxonomie "+window.$config.taxonomies[i].slug+" for stelle "+stelle.post_title);
          stelle[window.$config.taxonomies[i].slug] = that.getAllItems(stelle.taxonomies[window.$config.taxonomies[i].slug]);
          stelle.taxonomieSting += that.getAllItems(stelle.taxonomies[window.$config.taxonomies[i].slug])+"";
          stelle.taxonomieSting = stelle.taxonomieSting.replaceAll("undefined ", "");
        }
        stelle.schlagwortString = "";
        stelle.schlagworte.forEach(function(wort){
          stelle.schlagwortString = stelle.schlagwortString + " " + wort.name;
        });
      });
      console.log(this.stellen);
      this.stellenOrig = this.stellen;
    },
    getAllItems(parent){
      let itemstring = "";
      for(let i=0; i < parent.length; i++){
        itemstring = itemstring + " " + parent[i].name;
      }
      return itemstring;
    },
    filterPostsByTerms(){
      this.stellen = this.stellenOrig;

      let filterSet = false;
      for(let i=0; i < this.taxonomies.length; i++){
        this.taxonomies[i].titleTxt = this.taxonomies[i].title;
        if(this.taxonomySelected[i].length > 0){
          this.taxonomies[i].titleTxt = this.taxonomies[i].titleTxt + " (" + this.taxonomySelected[i].length + ")";
          filterSet = true;
        }
      }

      /*
      //hack to update v-for
      let dummy = {"show": false};
      this.taxonomies.push(dummy);
      this.taxonomies.pop();*/

    if(filterSet){
      let stellenTmp = [];
      for(let t=0; t < this.taxonomies.length; t++) {
        if(this.taxonomySelected[t].length > 0){
          for (let i = 0; i < this.taxonomySelected[t].length; i++) {
            let term = this.taxonomySelected[t][i];
            for (let j = 0; j < this.stellenOrig.length; j++) {
              let stelle = this.stellenOrig[j];
              for (let k = 0; k < stelle.taxonomies[this.taxonomies[t].slug].length; k++) {
                let f_tmp = stelle.taxonomies[this.taxonomies[t].slug][k];
                if (f_tmp.name == term) {
                  let found = false;
                  for(let m = 0; m < stellenTmp.length; m++){
                    if(stellenTmp[m].ID == stelle.ID){
                      found = true;
                    }
                  }
                  if(!found){
                    stellenTmp.push(stelle);
                  }

                }
              }
            }
          }
        }

      }
      this.stellen = stellenTmp;
    }

      if(this.orteSelected.length > 0 || this.firmenSelected.length > 0 || this.arbeitsbereicheSelected.length > 0){
        let stellenTmp = [];
        if(this.firmenSelected.length > 0) {
          for (let i = 0; i < this.firmenSelected.length; i++) {
            let firma = this.firmenSelected[i];
            for (let j = 0; j < this.stellenOrig.length; j++) {
              let stelle = this.stellenOrig[j];
              for (let k = 0; k < stelle.firmen.length; k++) {
                let f_tmp = stelle.firmen[k];
                if (f_tmp.name == firma) {
                  stellenTmp.push(stelle);
                }
              }
            }
          }
          this.stellen = stellenTmp;
        }
        stellenTmp = [];
        if(this.orteSelected.length > 0) {
          for (let i = 0; i < this.orteSelected.length; i++) {
            let ort = this.orteSelected[i];
            for (let j = 0; j < this.stellen.length; j++) {
              let stelle = this.stellen[j];
              for (let k = 0; k < stelle.orte.length; k++) {
                let tmp = stelle.orte[k];
                if (tmp.name == ort) {
                  stellenTmp.push(stelle);
                }
              }
            }
          }
          this.stellen = stellenTmp;
        }
        stellenTmp = [];
        if(this.arbeitsbereicheSelected.length > 0) {
          for (let i = 0; i < this.arbeitsbereicheSelected.length; i++) {
            let arbeitsbereich = this.arbeitsbereicheSelected[i];
            for (let j = 0; j < this.stellen.length; j++) {
              let stelle = this.stellen[j];
              for (let k = 0; k < stelle.arbeitsbereiche.length; k++) {
                let tmp = stelle.arbeitsbereiche[k];
                if (tmp.name == arbeitsbereich) {
                  stellenTmp.push(stelle);
                }
              }
            }
          }
          this.stellen = stellenTmp;
        }

      }
    }

  },
  components: {
  },
  computed:{
    headers(){

      let compHeaders = [
        {
          text: "",
          align: 'start',
          sortable: false,
          value: 'post_image',
        },
        {
          text: "",
          align: 'start',
          sortable: false,
          value: 'post_text',
        }
    ];


    if(this.appTypeIsEB) {
      compHeaders.shift();
      for (let i = 0; i < window.$config.taxonomies.length; i++) {
        //console.log("title: "+window.$config.taxonomies[i].title+" slug: "+window.$config.taxonomies[i].slug);
        let tmp = {
          text: window.$config.taxonomies[i].title,
          align: 'start',
          sortable: false,
          value: window.$config.taxonomies[i].slug,
        };
        compHeaders.push(tmp);
      }
    }

      let titles ={
        text: "Titel",
        align: ' d-none',
        sortable: false,
        value: 'post_title',
      };
      compHeaders.push(titles);

      let keywords =       {
        text: "Schlagworte",
        align: ' d-none',
        sortable: false,
        value: 'schlagwortString',
      };
      compHeaders.push(keywords);

      let desc =       {
        text: "Description",
        align: ' d-none',
        sortable: false,
        value: 'description_html',
      };
      compHeaders.push(desc);
      let exc = {
        text: "Excerpt",
        align: ' d-none',
        sortable: false,
        value: 'post_excerpt',
      }
      compHeaders.push(exc);
      return compHeaders;
    },
    appTypeIsSaf() {
      return window.$config.APP_TYPE === "saf";
    },
    appTypeIsEB() {
      return window.$config.APP_TYPE === "eb";
    }
  },
  watch: {
    "query.text"() {
      this.debounceSearchText()
    },
    taxonomySelected(newVal){
      this.filterPostsByTerms(newVal);
      let totalTax = 0;
      for(let i=0; i < this.taxonomySelected.length; i++){
        totalTax += this.taxonomySelected[i].length;
      }
      if(totalTax > 0){
        document.getElementById('nofilterhint').style.display = "none";
        this.showNoFilterText = false;
      }else{
        document.getElementById('nofilterhint').style.display = "block";
        this.showNoFilterText = true;
      }
    },
    firmenSelected(newVal, oldVal){
      this.filterPostsByTerms(newVal, oldVal);
    },
    orteSelected(newVal){
      this.filterPostsByTerms(newVal);
    },
    arbeitsbereicheSelected(newVal){
      this.filterPostsByTerms(newVal);
    }
  },
  mounted() {
    this.taxonomies = window.$config.taxonomies;
    for(let i=0; i < this.taxonomies.length; i++){
      this.taxonomies[i].show = false;
      this.taxonomySelected[i] = [];
      this.taxonomies[i].titleTxt = this.taxonomies[i].title;
    }
    this.taxonomies[0].show = true;
    this.getTaxonomies();
    this.getStellen();
  },
  created() {
    this.debounceSearchText = _.debounce(function() {
      this.queryInfo()
    }, 500)
  }
}
